var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.9926 15.9532H11.2983C10.7428 15.9532 10.2909 16.4123 10.2909 16.9766C10.2909 17.5421 10.7428 18 11.2983 18H16.9926C17.5482 18 18 17.5421 18 16.9766C18 16.4123 17.5482 15.9532 16.9926 15.9532Z",
    fill: "#219653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30902 3.90388L12.7049 8.26397C12.835 8.36824 12.8573 8.55959 12.7557 8.69289L6.35874 17.0282C5.95662 17.5431 5.36402 17.8345 4.72908 17.8452L1.23696 17.8882C1.05071 17.8904 0.887748 17.7614 0.845419 17.5765L0.0517547 14.1258C-0.0858138 13.4916 0.0517547 12.8358 0.453878 12.3306L6.88256 3.95548C6.98627 3.82111 7.1778 3.79746 7.30902 3.90388Z",
    fill: "#219653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.1206 5.66544L14.0804 6.96401C13.9756 7.09623 13.7872 7.11773 13.6571 7.01238C12.3925 5.98901 9.15436 3.36285 8.25593 2.63509C8.12471 2.52759 8.10672 2.33625 8.21254 2.20295L9.21574 0.957057C10.1258 -0.214663 11.7131 -0.322161 12.9936 0.699064L14.4645 1.87078C15.0677 2.34377 15.4698 2.96726 15.6074 3.62299C15.7661 4.3443 15.5968 5.0527 15.1206 5.66544Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon1);
export default __webpack_public_path__ + "static/media/action-icon-1.1d635529fa0fc39cb30596c373de6c24.svg";
export { ForwardRef as ReactComponent };